import React from 'react';
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import BG from "../About/assets/bg_about.webp";
import InnerPage from "../../components/InnerPage";
import Container from "../../components/Container";
import Button from "../../components/Button";
import styles from "./404.module.scss";
import Page from "../../components/Page";
const Page404 = () => {
  const [t] = useTranslation("global");

  return (
    <Page>
      <Helmet>
        <title>RedBark Studio | 404</title>
      </Helmet>
      <InnerPage className={styles.wrapper} background={BG}>
        <Container>
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className={styles.content}>
                <h1 className={styles.title}>404</h1>
                <p className={styles.desc}>{t("page_not_found.text")}</p>
                <Button className={styles.button} text={t("buttons.home")} to={"/"} type={"link"}/>
              </div>
            </div>
          </div>
        </Container>
      </InnerPage>
    </Page>
  );
};

export default Page404;